import React, { useState } from 'react';
import Select from 'react-select';
import { SelectOption } from 'lib/components/types';
import { InventoryUnitType } from 'lib/util';
import { useWindowResize } from 'hooks/useWindowResize';
import { Typography } from 'lib/components';
import classes from './index.module.scss';

interface Props {
	value?: InventoryUnitType;
	setValue: React.Dispatch<React.SetStateAction<number | undefined>>;
	style?: React.CSSProperties;
}

const options: SelectOption<InventoryUnitType>[] = [
	{ label: 'ML', value: 0 },
	{ label: 'L', value: 1 },
	{ label: 'G', value: 2 },
	{ label: 'MG', value: 3 },
];

const InventoryUnitTypeSelect = ({ value, setValue, style }: Props) => {
	const { isSmallerDevice } = useWindowResize();
	const [option, setOption] = useState<SelectOption<InventoryUnitType> | null>(
		typeof value !== undefined ? options.find((option) => option.value === value)! : null
	);

	const handleChange = (option: SelectOption<InventoryUnitType> | null) => {
		setOption(option);
		setValue(option!.value);
	};

	return (
		<div className={classes['textfield-container']} style={style}>
			<Typography color="darkgrey" variant={isSmallerDevice ? 'h5' : 'subheading2'}>
				Inventory Unit Type:
			</Typography>
			<Select
				className={classes['react-select-container']}
				classNamePrefix="react-select"
				options={options}
				value={option}
				onChange={handleChange}
			/>
		</div>
	);
};

export default InventoryUnitTypeSelect;
